export enum Modals {
  language = 'language',
  contentViewingPrefs = 'content_viewing_prefs',
}
